<div [class]="'theme-wrapper ' + themeClass">
  <router-outlet></router-outlet>
</div>
